/**
 * Lavelle LocalStorage Wishlist Manager
 */

class WishlistManager {
  constructor() {
    this.storageKey = 'lavelle_wishlist_items';
    this.items = this.load();
    this.countBadges = document.querySelectorAll('[data-wishlist-count]');

    this.init();
  }

  init() {
    this.updateBadges();
    this.syncButtons();
    this.bindEvents();
    this.renderWishlistPage();
  }

  load() {
    try {
      const data = localStorage.getItem(this.storageKey);
      return data ? JSON.parse(data) : [];
    } catch (e) {
      return [];
    }
  }

  save() {
    try {
      localStorage.setItem(this.storageKey, JSON.stringify(this.items));
    } catch (e) {}
    this.updateBadges();
    this.syncButtons();
  }

  bindEvents() {
    document.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-wishlist-toggle]');
      if (!btn) return;
      e.preventDefault();

      const product = {
        id: btn.dataset.productId,
        handle: btn.dataset.productHandle,
        title: btn.dataset.productTitle,
        price: btn.dataset.productPrice,
        image: btn.dataset.productImage,
        url: btn.dataset.productUrl
      };

      this.toggle(product);
    });
  }

  toggle(product) {
    const index = this.items.findIndex(item => item.handle === product.handle || item.id === product.id);
    if (index > -1) {
      this.items.splice(index, 1);
      this.save();
      if (window.Lavelle?.showToast) {
        window.Lavelle.showToast(`Removed "${product.title}" from your wishlist.`);
      }
    } else {
      this.items.push(product);
      this.save();
      if (window.Lavelle?.showToast) {
        window.Lavelle.showToast(`Saved "${product.title}" to your wishlist.`);
      }
    }
    this.renderWishlistPage();
  }

  isInWishlist(handle, id) {
    return this.items.some(item => (handle && item.handle === handle) || (id && item.id === id));
  }

  updateBadges() {
    this.countBadges.forEach(badge => {
      badge.textContent = this.items.length;
      badge.style.display = this.items.length > 0 ? 'inline-flex' : 'none';
    });
  }

  syncButtons() {
    document.querySelectorAll('[data-wishlist-toggle]').forEach(btn => {
      const handle = btn.dataset.productHandle;
      const id = btn.dataset.productId;
      if (this.isInWishlist(handle, id)) {
        btn.classList.add('active');
        btn.setAttribute('aria-label', 'Remove from wishlist');
      } else {
        btn.classList.remove('active');
        btn.setAttribute('aria-label', 'Add to wishlist');
      }
    });
  }

  renderWishlistPage() {
    const container = document.getElementById('wishlist-grid-container');
    const emptyState = document.getElementById('wishlist-empty-state');
    if (!container) return;

    if (this.items.length === 0) {
      container.innerHTML = '';
      if (emptyState) emptyState.style.display = 'block';
      return;
    }

    if (emptyState) emptyState.style.display = 'none';

    container.innerHTML = this.items.map(item => `
      <div class="product-card" data-wishlist-item="${item.id}">
        <div class="product-card-media">
          <a href="${item.url}">
            <img src="${item.image}" alt="${item.title}" class="primary-img" loading="lazy">
          </a>
          <button type="button" class="product-card-wishlist active" data-wishlist-toggle data-product-id="${item.id}" data-product-handle="${item.handle}" data-product-title="${item.title}" data-product-price="${item.price}" data-product-image="${item.image}" data-product-url="${item.url}" title="Remove from wishlist">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" stroke="currentColor" stroke-width="1.5"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path></svg>
          </button>
        </div>
        <div class="product-card-info">
          <h3 class="product-card-title"><a href="${item.url}">${item.title}</a></h3>
          <div class="product-card-price">${item.price}</div>
          <div style="display: flex; gap: 0.5rem; margin-top: 1rem;">
            <a href="${item.url}" class="btn btn-primary" style="flex: 1; font-size: 0.78rem; padding: 0.5rem 0.75rem; text-align: center;">Add to Bag</a>
            <a href="${item.url}" class="btn btn-secondary" style="font-size: 0.78rem; padding: 0.5rem 0.75rem; text-align: center;">Quick View</a>
          </div>
        </div>
      </div>
    `).join('');
  }
}

document.addEventListener('DOMContentLoaded', () => {
  window.LavelleWishlist = new WishlistManager();
});

window.toggleShopifyWishlist = function(productId, title, price, img, url) {
  if (window.LavelleWishlist) {
    window.LavelleWishlist.toggle({
      id: productId || 'demo-pdp',
      handle: 'product-' + (productId || 'item'),
      title: title || document.getElementById('MainProductTitle')?.textContent || 'Product',
      price: price || document.getElementById('ProductSellingPrice')?.textContent || '€175.00',
      image: img || document.getElementById('MainProductBigImg')?.src || '',
      url: url || window.location.href
    });
  } else if (window.Lavelle?.showToast) {
    window.Lavelle.showToast('Item saved to your Wishlist!');
  } else {
    alert('Item saved to your Wishlist!');
  }
};
